import { useEffect } from "react";

export const ORIGIN = typeof window !== "undefined" ? window.location.origin : "";

function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

/**
 * useSeo, sets title, meta description, canonical, OG/Twitter, and injects JSON-LD.
 */
export function useSeo({ title, description, path = "", image, jsonLd = [] }) {
  useEffect(() => {
    const canonical = `${ORIGIN}${path}`;
    if (title) document.title = title;
    setMeta("name", "description", description);
    setLink("canonical", canonical);
    // Open Graph
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:url", canonical);
    setMeta("property", "og:site_name", "RPM Auto Repair");
    if (image) setMeta("property", "og:image", image);
    // Twitter
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    if (image) setMeta("name", "twitter:image", image);

    const nodes = [];
    (Array.isArray(jsonLd) ? jsonLd : [jsonLd]).filter(Boolean).forEach((obj) => {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.setAttribute("data-seo", "1");
      s.text = JSON.stringify(obj);
      document.head.appendChild(s);
      nodes.push(s);
    });
    return () => nodes.forEach((n) => n.remove());
  }, [title, description, path, image, JSON.stringify(jsonLd)]);
}

export const breadcrumbLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: `${ORIGIN}${it.path}`,
  })),
});

export const faqLd = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q || f.question,
    acceptedAnswer: { "@type": "Answer", text: f.a || f.answer },
  })),
});
